<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">

        <div class="form-group row">
          <app-input [label]="'name'" [formControl]="form_name"></app-input>
          <app-input [label]="'email'" [formControl]="form_email"></app-input>
        </div>

        <div class="form-group row">
          <app-input [label]="'resume'" [formControl]="form_summary" [size]="12"></app-input>
        </div>

        <div class="form-group row">
          <app-select [label]="'companyService'" [formControl]="form_services" [size]="12" [list]="serviceList"
            [isEnum]="true" enumName="ServiceType"></app-select>
        </div>

        <div class="form-group row">
          <app-input [label]="'description'" [formControl]="form_description" [size]="12"
            [isTextarea]="true"></app-input>
        </div>

        <div class="form-group row">
          <app-input [label]="'phoneNumber'" [formControl]="form_phoneNumber"></app-input>
          <app-input [label]="'webSite'" [formControl]="form_website"></app-input>
        </div>

        <div class="form-group row">
          <app-input [label]="'siret'" [formControl]="form_siret"></app-input>
          <app-input [label]="'vatNumber'" [formControl]="form_vatNumber"></app-input>
        </div>

        <app-address-form formControlName="address"></app-address-form>
      </form>
    </div>
  </div>
</ng-template>
